export default "__VITE_ASSET__86ghqh8x__"